import { MobileMediaField } from '../../shared/models/MobileMediaField';
import { BaseZenputModel } from '../../../backbone-unorganized/shared/forms';

/**
 * An image/video field for form fields on a form submission with logic required for uploading.
 */
export const MediaFieldFormSubmission = MobileMediaField.extend({
    get_parent_upload_guid: function () {
        this.collection.set_guid(); // make sure this is set; it may not be if the structure hasn't been changed yet

        return this.collection.smetadata.get('guid');
    },

    create_field_upload_filename: function (file_entry) {
        return $f.storage.create_form_submission_media_filename(
            this.get('type') === 'signature' ? 'zp-signature.png' : file_entry.name,
            this.collection.metadata.get('rdbms_id'),
            this.collection.metadata.get('company').id
        );
    }
});

export const LocationFieldOrder = BaseZenputModel.extend({
    // TODO: Enable caching. Currently if we enable this the first 404 GET request is duplicated
    // cache_enabled: true,
    // fetch: function() {
    //     this.cache_key = `activity-field-location-ordering-${this.attributes.activity.id}-${this.attributes.location.id}`;
    //     Backbone.Model.prototype.fetch.apply(this, arguments);
    // },
    url: function () {
        const activity_template = this.get('activity_template');
        const location = this.get('location');
        return `/api/v3/activities/templates/${activity_template.id}/location_field_order/${location.id}`;
    },
    parse: function (response) {
        return response.data;
    },
    defaults: {
        id: null,
        activity: null,
        location: null,
        modified_user: null,
        field_order: null,
        date_modified: null,
        date_created: null
    }
});
